import { Divider } from '@mui/material';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { customSizes } from '../../../assets/styles/themes/tokens';
import { READER_ZOOM_FACTOR } from '../../../constants';
import { selectUser } from '../../../reducers/user.selectors';
import { ReaderContext } from '../../Reader/ReaderContext';
import type { FloatingToolbarCommonProps } from './FloatingToolbarBase';
import SearchInput from './SearchInput';
import SelectZoom from './SelectZoom';
import SwitchMode from './SwitchMode';

const FloatingToolbarDivider: React.FC = () => {
	return (
		<Divider
			orientation="vertical"
			flexItem
			sx={{
				height: customSizes.floatingToolbar.height,
				alignSelf: 'center',
			}}
		/>
	);
};

const FloatingBarLargeContent: React.FC<FloatingToolbarCommonProps> = (props) => {
	const { searchInputProps } = props;
	const user = useSelector(selectUser);
	const {
		zoomProperties: { zoomFactor, setZoomFactor, baselineZoomFactor },
		setFullScreenMode,
		fullScreenMode,
		setAlert,
		isTextBased,
	} = useContext(ReaderContext);
	const { t } = useTranslation();
	const showSearchInput = !fullScreenMode && user?.hasDocumentLevelAccess;

	return (
		<>
			{showSearchInput && (
				<>
					<SearchInput
						onChange={searchInputProps?.onSearchInputChange}
						onNext={searchInputProps?.onSearchNext}
						onPrevious={searchInputProps?.onSearchPrevious}
						endAdornment={searchInputProps?.endAdornment}
						placeholder={searchInputProps?.placeholder}
						isDisabled={searchInputProps?.isDisabled}
						value={searchInputProps?.value}
						onMouseOver={() => {
							if (!isTextBased) {
								setAlert?.({
									message: t('Search is not possible in this document.'),
									severity: 'info',
								});
							}
						}}
						inputProps={{
							sx: {
								width: customSizes.searchInput.width.desktop,
							},
						}}
					/>
					<FloatingToolbarDivider />
				</>
			)}
			<SelectZoom
				factor={zoomFactor}
				onZoomChange={(number) => {
					setZoomFactor?.(number);
				}}
				sliderProps={{
					min: baselineZoomFactor < 1 ? READER_ZOOM_FACTOR.SeventyFive : READER_ZOOM_FACTOR.Fifty,
					max: 200,
					step: 25,
				}}
			/>
			<FloatingToolbarDivider />
			<SwitchMode checked={fullScreenMode} onChange={setFullScreenMode ?? (() => {})} />
		</>
	);
};

export default FloatingBarLargeContent;
